/***
 * PC_ADF_01 importing the api function calls
 */
import { useState, useEffect } from 'react';
import React from 'react';
import { getCountry, getState, postEmployeeAddress, getEmployeeAddress, getNotificationId } from '../service/DirectorAPI';
import { OnlyNumberSpecialChar, NotificationTrigger } from '../../src/utils/RegHandling';
import $ from 'jquery';
import { connect } from 'react-redux';
import { encryptStorage } from '../constant';

function AddressDetail(props) {
    /***
     * PC_ADF_02
     * Declaring the state variables and objects
     */

    let dataObj = {
        id: '',
        currentHouseNo: '',
        currentstreet: '',
        currentarea: '',
        currentcity: '',
        currentpincode: '',
        currentcountry: 'selected',
        currentstate: 'selected',
        sameascurrentaddress: 0,
        perhousenumber: '',
        perstreet: '',
        perarea: '',
        pertown: '',
        percountry: 'selected',
        perstate: 'selected',
        perpincode: '',
    };
    const [state, setState] = useState(dataObj);
    let dropDownArraycurrentcountry = [];
    const [arrDropDowncurrentcountry, setarrDropDowncurrentcountry] = useState(dropDownArraycurrentcountry);
    let dropDownArraycurrentstate = [];
    const [arrDropDowncurrentstate, setarrDropDowncurrentstate] = useState(dropDownArraycurrentstate);
    let dropDownArraypercountry = [];
    const [arrDropDownpercountry, setarrDropDownpercountry] = useState(dropDownArraypercountry);
    let dropDownArrayperstate = [];
    const [arrDropDownperstate, setarrDropDownperstate] = useState(dropDownArrayperstate);

    let oldvalue = {
        same_as_current_addr: 0,
        house_num: '',
        street: '',
        area: '',
        town: '',
        state: '',
        country: '',
        pincode: '',
    };

    const [Oldvalue, setOldvalue] = useState(oldvalue);
    let [pagemode, setpagemode] = useState('false');
    const [addressType, setaddressType] = useState('');
    const [showPermanentField, setshowPermanentField] = useState(false);

    let [EmpId, setEmpId] = useState(props.State);
    const [submit, setSubmit] = useState('Save');
    let loginEmpId = encryptStorage.getItem('employeeId');
    let role = encryptStorage.getItem('role');
    const [DisableSubmitBtn, setDisableSubmitBtn] = useState(false);
    let validationFields = {
        currentHouseNo: '',
        currentstreet: '',
        currentarea: '',
        currentcity: '',
        currentpincode: '',
        currentcountry: '',
        currentstate: '',
        perhousenumber: '',
        perstreet: '',
        perarea: '',
        pertown: '',
        percountry: '',
        perstate: '',
        perpincode: '',
    };
    const [message, setmessage] = useState(validationFields);

    let rejexvalidation = {
        currentpincode: '',
        perpincode: '',
    };
    const [rejexMessage, setRejexMessage] = useState(rejexvalidation);
    const [notification, setNotification] = useState([]);
    const [hideForm, setHideForm] = useState(true);
    const [reportstoId, setReportstoId] = useState('');

    useEffect(() => { }, [props.IsAddrClick]);

    /***
     * PC_ADF_03
     * useEffect method get invoked and make a dropdown api calls
     */

    useEffect(() => {
        if (props.IsAddrClick) {
            // let element = document.getElementById("removeScroll");
            // element.classList.add("removeScroll");

            $('body').addClass('removeScroll');

            setHideForm(false);
            LoadDatacurrentcountry();
            LoadDatapercountry();

            if (props.empId != undefined) {
                setEmpId(props.empId);
            }
            if (props.Mode != undefined) {
                if (props.Mode == 'Edit') {
                    setpagemode('true');
                    setSubmit('Update');
                } else {
                    setpagemode('false');
                    setSubmit('Save');
                }
            }
            if (props.Type != undefined) {
                setaddressType(props.Type);
            }

            let objedit = {
                emp_id: props.empId,
                reports_to: loginEmpId,
                address_type: props.Type,
                role: role,
            };
            selecteditarray(objedit, props.Type);
        }
    }, [props]);

    /***
     * PC_ADF_04
     * these functions fetch the data from Data Base
     */

    const LoadDatacurrentcountry = async () => {
        let countryData = {};
        let responsedata = await getCountry(countryData);
        setarrDropDowncurrentcountry(responsedata.data.ResponseData[0]);
    };

    const LoadDatapercountry = async () => {
        let countryData = {};
        let responsedata = await getCountry(countryData);
        setarrDropDownpercountry(responsedata.data.ResponseData[0]);
    };

    /**
     *
     * PC_ADF_05 this function get the data from the database and store into the statevariable
     */
    const LoadDatacurrentstate = async (e) => {
        let countryId = { country_id: e.target.value };
        let responsedata = await getState(countryId);
        setarrDropDowncurrentstate(responsedata.data.ResponseData[0]);
    };

    const EditLoadDatacurrentstate = async (e) => {
        let countryId = { country_id: e };
        let responsedata = await getState(countryId);
        setarrDropDowncurrentstate(responsedata.data.ResponseData[0]);
    };

    const LoadDataperstate = async (e) => {
        let countryId = { country_id: e.target.value };
        let responsedata = await getState(countryId);
        setarrDropDownperstate(responsedata.data.ResponseData[0]);
    };

    const EditLoadDataperstate = async (e) => {
        let countryId = { country_id: e };
        let responsedata = await getState(countryId);
        setarrDropDownperstate(responsedata.data.ResponseData[0]);
    };

    /***
     * PC_ADF_21
     * this function will make the api call and fill the data in the fields
     * and hide and show the address fields
     */

    const handleChecked = (e) => {
        e.target.checked == true ? setState({ ...state, [e.target.name]: 1 }) : setState({ ...state, [e.target.name]: 0 });

        e.target.checked == true ? setCurrentAsPermanentValue() : clearPermanentValue();

        message.perhousenumber = '';
        message.perstreet = '';
        message.perarea = '';
        message.pertown = '';
        message.perstate = '';
        message.percountry = '';
        message.perpincode = '';
        setmessage({ ...message });
    };

    /***
     * PC_ADF_12
     * setstate the values into the state object
     */

    const OnChangeName = (e) => {

        setState({ ...state, [e.target.name]: e.target.value });
        setmessage({ ...message, [e.target.name]: '' });
        e.preventDefault();
        var regexItem;
        var checkValid;
        const currcountry = state.currentcountry;
        const percountry = state.percountry;
        
        if (e.target.name == 'currentpincode') {
                regexItem = (currcountry==1)? new RegExp('^[0-9]*$'): new RegExp('^[A-Za-z0-9]+$')
            checkValid = regexItem.test(e.target.value);
            if (checkValid == false) {
                rejexMessage.currentpincode = 'Enter a Valid Pincode';
                setRejexMessage({ ...rejexMessage });
            } else {
                rejexMessage.currentpincode = '';
                setRejexMessage({ ...rejexMessage });
            }
        }

        if (e.target.name == 'perpincode') {
           regexItem = (percountry==1)? new RegExp('^[0-9]*$'): new RegExp('^[A-Za-z0-9]+$')
             checkValid = regexItem.test(e.target.value);
            if (checkValid == false) {
                rejexMessage.perpincode = 'Enter a Valid Pincode';
                setRejexMessage({ ...rejexMessage });
            } else {
                rejexMessage.perpincode = '';
                setRejexMessage({ ...rejexMessage });
            }
        }
    };

    const setCurrentAsPermanentValue = () => {
        state.perhousenumber = state.currentHouseNo;
        state.perstreet = state.currentstreet;
        state.perarea = state.currentarea;
        state.pertown = state.currentcity;
        state.percountry = state.currentcountry;
        state.perstate = state.currentstate;
        state.perpincode = state.currentpincode;
        state.sameascurrentaddress = 1;

        setState({ ...state });
        EditLoadDataperstate(state.currentcountry);
    };

    /***
     * PC_ADF_12
     * this function clear the permanent field values
     */

    const clearPermanentValue = () => {
        state.perhousenumber = '';
        state.perstreet = '';
        state.perarea = '';
        state.pertown = '';
        state.percountry = 'selected';
        state.perstate = 'selected';
        state.perpincode = '';
        state.sameascurrentaddress = 0;
        setState({ ...state });
    };
    //PC_ADF_11
    //Build the drop down functions
    const buildcurrentcountry = () => {
        return arrDropDowncurrentcountry.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };

    const buildcurrentstate = () => {
        return arrDropDowncurrentstate.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };

    const buildpercountry = () => {
        return arrDropDownpercountry.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };

    const buildperstate = () => {
        return arrDropDownperstate.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };

    /***
     * PC_ADF_11.1
     * clear the fields when user clicks the cancel and close button
     */
    const cancelClick = () => {
        let valiclearoption = {
            currentHouseNo: '',
            currentstreet: '',
            currentarea: '',
            currentcity: '',
            currentpincode: '',
            currentcountry: 'selected',
            currentstate: 'selected',
            sameascurrentaddress: 0,
            perhousenumber: '',
            perstreet: '',
            perarea: '',
            pertown: '',
            percountry: 'selected',
            perstate: 'selected',
            perpincode: '',
        };
        setState(valiclearoption);
        setshowPermanentField(false);

        let clearvalidationFields = {
            currentHouseNo: '',
            currentstreet: '',
            currentarea: '',
            currentcity: '',
            currentpincode: '',
            currentcountry: '',
            currentstate: '',
            perhousenumber: '',
            perstreet: '',
            perarea: '',
            pertown: '',
            percountry: '',
            perstate: '',
            perpincode: '',
        };
        setmessage(clearvalidationFields);
        rejexMessage.currentpincode = '';
        setRejexMessage({ ...rejexMessage });
        rejexMessage.perpincode = '';
        setRejexMessage({ ...rejexMessage });
        props.setISAddressClick(false);
        setHideForm(true);

        // let element = document.getElementById("removeScroll");
        // element.classList.remove("removeScroll");

        $('body').removeClass('removeScroll');
    };

    /***
     * PC__ADF_11
     * this function display the validation message when user submit the form without required fields
     */
    const validation = () => {
        if ((pagemode === 'true' && addressType === 'Current Address') || pagemode === 'false') {
            if (state.currentHouseNo.trim() == '') {
                message.currentHouseNo = 'House/building is required';
                setmessage({ ...message });
            } else {
                message.currentHouseNo = '';
                setmessage({ ...message });
            }
            if (state.currentstreet.trim() == '') {
                message.currentstreet = 'Road/Street/Lane is required';
                setmessage({ ...message });
            } else {
                message.currentstreet = '';
                setmessage({ ...message });
                let checkregex = OnlyNumberSpecialChar(state.currentstreet);
                if (checkregex) {
                    message.currentstreet = 'Enter a Valid Road/Street/Lane';
                    setmessage({ ...message });
                } else {
                    message.currentstreet = '';
                    setmessage({ ...message });
                }
            }

            if (state.currentarea.trim() == '') {
                message.currentarea = 'Area/Locality/Sub Division is required';
                setmessage({ ...message });
            } else {
                message.currentarea = '';
                setmessage({ ...message });
                let checkregex = OnlyNumberSpecialChar(state.currentarea);
                if (checkregex) {
                    message.currentarea = 'Enter a Valid Area/Locality/Sub Division';
                    setmessage({ ...message });
                } else {
                    message.currentarea = '';
                    setmessage({ ...message });
                }
            }

            if (state.currentcity.trim() == '') {
                message.currentcity = 'Town/City/District is required';
                setmessage({ ...message });
            } else {
                message.currentcity = '';
                setmessage({ ...message });

                let checkregex = OnlyNumberSpecialChar(state.currentcity);
                if (checkregex) {
                    message.currentcity = 'Enter a Valid Town/City/District';
                    setmessage({ ...message });
                } else {
                    message.currentcity = '';
                    setmessage({ ...message });
                }
            }
            if (state.currentpincode.trim() == '') {
                message.currentpincode = 'Pincode is required';
                setmessage({ ...message });
            } else {
                message.currentpincode = '';
                setmessage({ ...message });
            }
            if (state.currentcountry == '' || state.currentcountry == 'select' || state.currentcountry == 'selected') {
                message.currentcountry = 'Country is required';
                setmessage({ ...message });
            } else {
                message.currentcountry = '';
                setmessage({ ...message });
            }
            if (state.currentstate == '' || state.currentstate == 'select' || state.currentstate == 'selected') {
                message.currentstate = 'State is required';
                setmessage({ ...message });
            } else {
                message.currentstate = '';
                setmessage({ ...message });
            }
        }

        if ((pagemode === 'true' && addressType === 'Permanent Address') || pagemode === 'false') {
            if (state.perhousenumber.trim() == '') {
                message.perhousenumber = 'House/building is required';
                setmessage({ ...message });
            } else {
                message.perhousenumber = '';
                setmessage({ ...message });
            }

            if (state.perstreet.trim() == '') {
                message.perstreet = 'Road/Street/Lane is required';
                setmessage({ ...message });
            } else {
                message.perstreet = '';
                setmessage({ ...message });

                let checkregex = OnlyNumberSpecialChar(state.perstreet);
                if (checkregex) {
                    message.perstreet = 'Enter a Valid Road/Street/Lane';
                    setmessage({ ...message });
                } else {
                    message.perstreet = '';
                    setmessage({ ...message });
                }
            }

            if (state.perarea.trim() == '') {
                message.perarea = 'Area/Locality/Sub Division is required';
                setmessage({ ...message });
            } else {
                message.perarea = '';
                setmessage({ ...message });

                let checkregex = OnlyNumberSpecialChar(state.perarea);
                if (checkregex) {
                    message.perarea = 'Enter a Area/Locality/Sub Division';
                    setmessage({ ...message });
                } else {
                    message.perarea = '';
                    setmessage({ ...message });
                }
            }

            if (state.pertown.trim() == '') {
                message.pertown = 'Town/City/District is required';
                setmessage({ ...message });
            } else {
                message.pertown = '';
                setmessage({ ...message });

                let checkregex = OnlyNumberSpecialChar(state.pertown);
                if (checkregex) {
                    message.pertown = 'Enter a Valid Town/City/District';
                    setmessage({ ...message });
                } else {
                    message.pertown = '';
                    setmessage({ ...message });
                }
            }
            if (state.perstate == 'selected' || state.perstate == '' || state.perstate == 'select') {
                message.perstate = 'State is required';
                setmessage({ ...message });
            } else {
                message.perstate = '';
                setmessage({ ...message });
            }
            if (state.percountry == 'selected' || state.percountry == '' || state.percountry == 'select') {
                message.percountry = 'Country is required';
                setmessage({ ...message });
            } else {
                message.percountry = '';
                setmessage({ ...message });
            }
            if (state.perpincode.trim() == '') {
                message.perpincode = 'Pincode is required';
                setmessage({ ...message });
            } else {
                message.perpincode = '';
                setmessage({ ...message });
            }
        }
    };

    /***
     * PC_ADF_14
     * this function will post the data into the Data Base
     */
    const submitClick = async () => {


        try {
            setDisableSubmitBtn(true);
            validation();
            //

            let isRejexValid = true;
            if (
                rejexMessage.perpincode != '' ||
                rejexMessage.currentpincode != '' ||
                message.currentHouseNo != '' ||
                message.currentstreet != '' ||
                message.currentarea != '' ||
                message.currentcity != '' ||
                message.currentpincode != '' ||
                message.perhousenumber != '' ||
                message.perstreet != '' ||
                message.perarea != '' ||
                message.pertown != '' ||
                message.perpincode != ''
            ) {
                isRejexValid = false;
            } else {
                isRejexValid = true;
            }
            /**
             * PC_ADF_20.1 this will make a post call to insert the data into the batadase
             */
            if (pagemode == 'false' && isRejexValid == true) {
                if (
                    state.currentHouseNo.trim() != '' &&
                    state.currentstreet.trim() != '' &&
                    state.currentarea.trim() != '' &&
                    state.currentcity.trim() != '' &&
                    state.currentpincode.trim() != '' &&
                    state.currentcountry != '' &&
                    state.currentstate != '' &&
                    state.perhousenumber.trim() != '' &&
                    state.perstreet.trim() != '' &&
                    state.perarea.trim() != '' &&
                    state.pertown.trim() != '' &&
                    state.percountry != '' &&
                    state.perstate != '' &&
                    state.perpincode.trim() != ''
                ) {
                    let insertdata = {
                        request_type: 'Insert',
                        emp_id: EmpId,
                        login_emp_id: loginEmpId,
                        cur_address_type: 'Current Address',
                        cur_house_num: state.currentHouseNo,
                        cur_street: state.currentstreet,
                        cur_area: state.currentarea,
                        cur_town: state.currentcity,
                        cur_pincode: state.currentpincode,
                        cur_country: state.currentcountry,
                        cur_state: state.currentstate,
                        same_as_current_addr: state.sameascurrentaddress,
                        per_address_type: 'Permanent Address',
                        per_house_num: state.perhousenumber,
                        per_street: state.perstreet,
                        per_area: state.perarea,
                        per_town: state.pertown,
                        per_country: state.percountry,
                        per_state: state.perstate,
                        per_pincode: state.perpincode,
                    };

                    let responsedata = await postEmployeeAddress(insertdata);
                    if (responsedata.data.status == 200) {
                        let valiclearoption = {
                            currentHouseNo: '',
                            currentstreet: '',
                            currentarea: '',
                            currentcity: '',
                            currentpincode: '',
                            currentcountry: 'selected',
                            currentstate: 'selected',
                            sameascurrentaddress: 0,
                            perhousenumber: '',
                            perstreet: '',
                            perarea: '',
                            pertown: '',
                            percountry: 'selected',
                            perstate: 'selected',
                            perpincode: '',
                        };
                        setState(valiclearoption);
                        setshowPermanentField(false);

                        props.setISAddressClick(false);
                        props.getEmployeeAddressGrid();
                        cancelClick();
                        props.showToast('Submitted', 'Submitted Succesfully');
                    }
                }
                /**
                 * PC_ADF_34.1 if the role is HR Manager the update will made directly with proper payload
                 */
            } else if (pagemode == 'true' && isRejexValid == true) {
                if (
                    (((role == 'Hr Manager' || role == 'Hr') && loginEmpId != EmpId) ||
                        (role == 'Hr Manager' && loginEmpId == EmpId && reportstoId == loginEmpId)) &&
                    addressType == 'Current Address'
                ) {
                    if (
                        state.currentHouseNo.trim() != '' &&
                        state.currentstreet.trim() != '' &&
                        state.currentarea.trim() != '' &&
                        state.currentcity.trim() != '' &&
                        state.currentpincode.trim() != '' &&
                        state.currentcountry != '' &&
                        state.currentstate != ''
                    ) {
                        let updatedata = {
                            request_type: 'Update',
                            login_emp_id: loginEmpId,
                            emp_id: EmpId,
                            id: state.id,
                            address_type: 'Current Address',
                            same_as_current_addr: 0,
                            house_num: state.currentHouseNo,
                            street: state.currentstreet,
                            area: state.currentarea,
                            town: state.currentcity,
                            state: state.currentstate,
                            country: state.currentcountry,
                            pincode: state.currentpincode,
                            role: role,
                        };

                        let responsedata = await postEmployeeAddress(updatedata);
                        if (responsedata.data.status == 200) {
                            let valiclearoption = {
                                currentHouseNo: '',
                                currentstreet: '',
                                currentarea: '',
                                currentcity: '',
                                currentpincode: '',
                                currentcountry: 'selected',
                                currentstate: 'selected',
                                sameascurrentaddress: 0,
                            };
                            setState(valiclearoption);

                            props.setISAddressClick(false);
                            props.getEmployeeAddressGrid();
                            cancelClick();
                            props.showToast('Updated', 'Updated Succesfully');
                        }
                    }
                    /**
                     * PC_ADF_34.1 if the role is HR Manager the update will made directly with proper payload
                     */
                } else if (
                    (((role == 'Hr Manager' || role == 'Hr') && loginEmpId != EmpId) ||
                        (role == 'Hr Manager' && loginEmpId == EmpId && reportstoId == loginEmpId)) &&
                    addressType == 'Permanent Address'
                ) {
                    if (
                        state.perhousenumber.trim() != '' &&
                        state.perstreet.trim() != '' &&
                        state.perarea.trim() != '' &&
                        state.pertown.trim() != '' &&
                        state.percountry != '' &&
                        state.perstate != '' &&
                        state.perpincode.trim() != ''
                    ) {
                        let updatedata = {
                            request_type: 'Update',
                            login_emp_id: loginEmpId,
                            emp_id: EmpId,
                            id: state.id,
                            address_type: 'Permanent Address',
                            same_as_current_addr: state.sameascurrentaddress,
                            house_num: state.perhousenumber,
                            street: state.perstreet,
                            area: state.perarea,
                            town: state.pertown,
                            state: state.perstate,
                            country: state.percountry,
                            pincode: state.perpincode,
                            role: role,
                        };

                        let responsedata = await postEmployeeAddress(updatedata);
                        if (responsedata.data.status == 200) {
                            let valiclearoption = {
                                currentHouseNo: '',
                                currentstreet: '',
                                currentarea: '',
                                currentcity: '',
                                currentpincode: '',
                                currentcountry: 'selected',
                                currentstate: 'selected',
                                sameascurrentaddress: 0,
                                perhousenumber: '',
                                perstreet: '',
                                perarea: '',
                                pertown: '',
                                percountry: 'selected',
                                perstate: 'selected',
                                perpincode: '',
                            };
                            setState(valiclearoption);

                            props.setISAddressClick(false);
                            props.getEmployeeAddressGrid();
                            cancelClick();
                            props.showToast('Updated', 'Updated Succesfully');
                        }
                    }
                    /***
                     * PC_ADF_34.2 if the role is Team Member
                     * dymamically binding the payload object for current and permanent address
                     */
                } else if ((role == 'Team Member' || loginEmpId == EmpId) && addressType == 'Current Address') {
                    if (
                        state.currentHouseNo.trim() != '' &&
                        state.currentstreet.trim() != '' &&
                        state.currentarea.trim() != '' &&
                        state.currentcity.trim() != '' &&
                        state.currentpincode.trim() != '' &&
                        state.currentcountry != '' &&
                        state.currentstate != ''
                    ) {
                        let newvalue = {
                            same_as_current_addr: 0,
                            house_num: state.currentHouseNo,
                            street: state.currentstreet,
                            area: state.currentarea,
                            town: state.currentcity,
                            state: state.currentstate,
                            country: state.currentcountry,
                            pincode: state.currentpincode,
                        };

                        let oldvalue = {
                            same_as_current_addr: 0,
                            house_num: Oldvalue.house_num,
                            street: Oldvalue.street,
                            area: Oldvalue.area,
                            town: Oldvalue.town,
                            state: Oldvalue.state,
                            country: Oldvalue.country,
                            pincode: Oldvalue.pincode,
                        };

                        var NewValue = Object.keys(newvalue);
                        var OldValue = Object.keys(oldvalue);
                        var log_data = '{';
                        for (let i = 0; i <= NewValue.length; i++) {
                            if (newvalue[NewValue[i]] != oldvalue[OldValue[i]]) {
                                log_data +=
                                    '"' +
                                    NewValue[i] +
                                    '"' +
                                    ':' +
                                    '"' +
                                    "'" +
                                    newvalue[NewValue[i]] +
                                    "'" +
                                    ',' +
                                    "'" +
                                    oldvalue[OldValue[i]] +
                                    "'" +
                                    '"' +
                                    ',';
                            }
                            if (i == NewValue.length) {
                                log_data = log_data.slice(0, -1);
                                log_data = log_data + '}';
                            }
                        }

                        if (log_data != '{' && log_data != '}') {
                            let logData = JSON.parse(log_data);
                            let updatedata = {
                                request_type: 'Update',
                                login_emp_id: loginEmpId,
                                emp_id: EmpId,
                                category_id: state.id,
                                category: 'Current Address',
                                status: 'Pending',
                                role: 'Team Member',
                                log_data: logData,
                            };

                            let emp = [];
                            notification.map((obj, index) => {
                                emp.push(obj.emp_id);
                            });

                            if (Object.keys(logData).length > 0) {
                                let responsedata = await postEmployeeAddress(updatedata);
                                if (responsedata.data.status == 200) {
                                    let profileRequestId = responsedata.data.ResponseData[1];
                                    // PC_ADF_39.1 profile request notification is send to the hr manager.
                                    await NotificationTrigger(
                                        {
                                            title: 'Profile Update',
                                            message: 'Profile Request',
                                            route: '/profileupdate',
                                            state: { state: { profileRequestId: profileRequestId } },
                                            to_employee: emp,
                                            by: loginEmpId,
                                        },
                                        emp,
                                        props.websocket
                                    );

                                    let valiclearoption = {
                                        currentHouseNo: '',
                                        currentstreet: '',
                                        currentarea: '',
                                        currentcity: '',
                                        currentpincode: '',
                                        currentcountry: 'selected',
                                        currentstate: 'selected',
                                        sameascurrentaddress: 0,
                                        perhousenumber: '',
                                        perstreet: '',
                                        perarea: '',
                                        pertown: '',
                                        percountry: 'selected',
                                        perstate: 'selected',
                                        perpincode: '',
                                    };
                                    setState(valiclearoption);

                                    props.setISAddressClick(false);
                                    cancelClick();
                                    props.showToast('Profile Request submitted', 'Changes will be reflected after the approval');
                                }
                            }
                        } else {
                            cancelClick();
                        }
                    }
                } else if ((role == 'Team Member' || loginEmpId == EmpId) && addressType == 'Permanent Address') {
                    if (
                        state.perhousenumber.trim() != '' &&
                        state.perstreet.trim() != '' &&
                        state.perarea.trim() != '' &&
                        state.pertown.trim() != '' &&
                        state.percountry != '' &&
                        state.perstate != '' &&
                        state.perpincode.trim() != ''
                    ) {
                        let newvalue = {
                            same_as_current_addr: state.sameascurrentaddress,
                            house_num: state.perhousenumber,
                            street: state.perstreet,
                            area: state.perarea,
                            town: state.pertown,
                            state: state.perstate,
                            country: state.percountry,
                            pincode: state.perpincode,
                        };

                        let oldvalue = {
                            same_as_current_addr: Oldvalue.same_as_current_addr,
                            house_num: Oldvalue.house_num,
                            street: Oldvalue.street,
                            area: Oldvalue.area,
                            town: Oldvalue.town,
                            state: Oldvalue.state,
                            country: Oldvalue.country,
                            pincode: Oldvalue.pincode,
                        };

                        var NewValue = Object.keys(newvalue);
                        var OldValue = Object.keys(oldvalue);
                        var log_data = '{';
                        for (let i = 0; i <= NewValue.length; i++) {
                            if (newvalue[NewValue[i]] != oldvalue[OldValue[i]]) {
                                log_data +=
                                    '"' +
                                    NewValue[i] +
                                    '"' +
                                    ':' +
                                    '"' +
                                    "'" +
                                    newvalue[NewValue[i]] +
                                    "'" +
                                    ',' +
                                    "'" +
                                    oldvalue[OldValue[i]] +
                                    "'" +
                                    '"' +
                                    ',';
                            }
                            if (i == NewValue.length) {
                                log_data = log_data.slice(0, -1);
                                log_data = log_data + '}';
                            }
                        }

                        if (log_data != '{' && log_data != '}') {
                            let logData = JSON.parse(log_data);
                            let updatedata = {
                                request_type: 'Update',
                                login_emp_id: loginEmpId,
                                emp_id: EmpId,
                                category_id: state.id,
                                category: 'Permanent Address',
                                status: 'Pending',
                                role: 'Team Member',
                                log_data: logData,
                            };

                            let emp = [];
                            notification.map((obj, index) => {
                                emp.push(obj.emp_id);
                            });

                            if (Object.keys(logData).length > 0) {
                                let responsedata = await postEmployeeAddress(updatedata);
                                if (responsedata.data.status == 200) {
                                    let profileRequestId = responsedata.data.ResponseData[1];
                                    // PC_ADF_39.1 profile request notification is send to the hr manager.
                                    await NotificationTrigger(
                                        {
                                            title: 'Profile Update',
                                            message: 'Profile Request',
                                            route: '/profileupdate',
                                            state: { state: { profileRequestId: profileRequestId } },
                                            to_employee: emp,
                                            by: loginEmpId,
                                        },
                                        emp,
                                        props.websocket
                                    );

                                    let valiclearoption = {
                                        currentHouseNo: '',
                                        currentstreet: '',
                                        currentarea: '',
                                        currentcity: '',
                                        currentpincode: '',
                                        currentcountry: 'selected',
                                        currentstate: 'selected',
                                        sameascurrentaddress: 0,
                                        perhousenumber: '',
                                        perstreet: '',
                                        perarea: '',
                                        pertown: '',
                                        percountry: 'selected',
                                        perstate: 'selected',
                                        perpincode: '',
                                    };
                                    setState(valiclearoption);

                                    props.setISAddressClick(false);
                                    cancelClick();
                                    props.showToast('Profile Request submitted', 'Changes will be reflected after the approval');
                                }
                            }
                        } else {
                            cancelClick();
                        }
                    }
                }
            }
            setDisableSubmitBtn(false);
        } catch (e) {
            setDisableSubmitBtn(false);
        }
    };

    /**
     * PC_ADF_22
     * this function get the record from DB and bind into the respective fields
     */
    const selecteditarray = async (objedit, addressType) => {
        try {
            let responsedata = await getEmployeeAddress(objedit);

            if (responsedata.data != undefined && responsedata.data != null && responsedata.data.ResponseData[0].length != 0) {
                EditLoadDatacurrentstate(responsedata.data.ResponseData[0][0].country);
                EditLoadDataperstate(responsedata.data.ResponseData[0][0].country);

                let oldvalueobj = {
                    same_as_current_addr: responsedata.data.ResponseData[0][0].same_as_current_addr,
                    house_num: responsedata.data.ResponseData[0][0].house_num,
                    street: responsedata.data.ResponseData[0][0].street,
                    area: responsedata.data.ResponseData[0][0].area,
                    town: responsedata.data.ResponseData[0][0].town,
                    state: responsedata.data.ResponseData[0][0].state,
                    country: responsedata.data.ResponseData[0][0].country,
                    pincode: responsedata.data.ResponseData[0][0].pincode,
                };
                setOldvalue(oldvalueobj);

                if (addressType == 'Current Address') {
                    let valiDateobj1 = {
                        id: responsedata.data.ResponseData[0][0].id,
                        currentHouseNo: responsedata.data.ResponseData[0][0].house_num,
                        currentstreet: responsedata.data.ResponseData[0][0].street,
                        currentarea: responsedata.data.ResponseData[0][0].area,
                        currentcity: responsedata.data.ResponseData[0][0].town,
                        currentpincode: responsedata.data.ResponseData[0][0].pincode,
                        currentcountry: responsedata.data.ResponseData[0][0].country,
                        currentstate: responsedata.data.ResponseData[0][0].state,
                        sameascurrentaddress: responsedata.data.ResponseData[0][0].same_as_current_addr,
                    };

                    setState(valiDateobj1);
                } else if (addressType == 'Permanent Address') {
                    let objeditCurrent = {
                        emp_id: objedit.emp_id,
                        reports_to: objedit.reports_to,
                        address_type: 'Current Address',
                        role: objedit.role,
                    };
                    let currentaddressdata = await getEmployeeAddress(objeditCurrent);

                    let valiDateobj1 = {
                        id: responsedata.data.ResponseData[0][0].id,
                        perhousenumber: responsedata.data.ResponseData[0][0].house_num,
                        perstreet: responsedata.data.ResponseData[0][0].street,
                        perarea: responsedata.data.ResponseData[0][0].area,
                        pertown: responsedata.data.ResponseData[0][0].town,
                        perpincode: responsedata.data.ResponseData[0][0].pincode,
                        percountry: responsedata.data.ResponseData[0][0].country,
                        perstate: responsedata.data.ResponseData[0][0].state,
                        sameascurrentaddress: responsedata.data.ResponseData[0][0].same_as_current_addr,

                        currentHouseNo: currentaddressdata.data.ResponseData[0][0].house_num,
                        currentstreet: currentaddressdata.data.ResponseData[0][0].street,
                        currentarea: currentaddressdata.data.ResponseData[0][0].area,
                        currentcity: currentaddressdata.data.ResponseData[0][0].town,
                        currentpincode: currentaddressdata.data.ResponseData[0][0].pincode,
                        currentcountry: currentaddressdata.data.ResponseData[0][0].country,
                        currentstate: currentaddressdata.data.ResponseData[0][0].state,
                    };
                    setState(valiDateobj1);
                }
            }

            // notification
            let NotaficationData = await getNotificationId(objedit);
            setNotification(NotaficationData.data.ResponseData[0]);
            setReportstoId(NotaficationData?.data?.ResponseData[0][0]?.emp_id);
        } catch (e) { }
    };

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }} hidden={hideForm}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className="modal-title profile-popup-header" id="EducationalDetailsPopupLabel">
                            Address Details
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => cancelClick()}
                        />
                    </div>

                    <div className={pagemode == 'false' ? 'modal-body employeeInfoScroll' : 'modal-body'}>
                        {(pagemode === 'true' && addressType === 'Current Address') || pagemode === 'false' ? (
                            // < div
                            //   className="modal-body employeeInfoScroll"
                            // >
                            <div className="row mb-1">
                                <h1 className="profile-popup-subheader">Current Address</h1>
                                <div className="col-md-6 mb-4">
                                    <label htmlFor="currentaddress-house" className="form-label hive-form-label">
                                        House / Building no<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="currentaddress-house"
                                        aria-describedby="House / Building Name"
                                        name="currentHouseNo"
                                        placeholder="Enter here"
                                        value={state.currentHouseNo}
                                        maxLength={25}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.currentHouseNo ? (
                                        <label className="hive-form-mandatory">{message.currentHouseNo}</label>
                                    ) : null}
                                </div>
                                <div className="col-md-6 mb-4">
                                    <label htmlFor="currentaddress-street" className="form-label hive-form-label">
                                        Road / Street / Lane
                                        <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="currentaddress-street"
                                        aria-describedby="Road / Street / Lane"
                                        name="currentstreet"
                                        placeholder="Enter here"
                                        value={state.currentstreet}
                                        maxLength={225}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.currentstreet ? <label className="hive-form-mandatory">{message.currentstreet}</label> : null}
                                </div>
                                <div className="col-md-6 mb-4">
                                    <label htmlFor="currentaddress-locality" className="form-label hive-form-label">
                                        Area / Locality / Sub Division
                                        <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="currentaddress-locality"
                                        aria-describedby="Area / Locality / Sub Division"
                                        name="currentarea"
                                        placeholder="Enter here"
                                        maxLength={225}
                                        value={state.currentarea}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.currentarea ? <label className="hive-form-mandatory">{message.currentarea}</label> : null}
                                </div>
                                <div className="col-md-6 mb-4">
                                    <label htmlFor="currentaddress-town" className="form-label hive-form-label">
                                        Town / City / District
                                        <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="currentaddress-town"
                                        aria-describedby="Town / City / District"
                                        name="currentcity"
                                        placeholder="Enter here"
                                        maxLength={225}
                                        value={state.currentcity}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.currentcity ? <label className="hive-form-mandatory">{message.currentcity}</label> : null}
                                </div>
                                <div className="col-md-6 mb-4">
                                    <label htmlFor="currentaddress-country" className="form-label hive-form-label">
                                        Country<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        className="form-select hive-form-select"
                                        aria-label="Default select example"
                                        id="currentaddress-country"
                                        name="currentcountry"
                                        value={state.currentcountry}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                            LoadDatacurrentstate(e);
                                        }}
                                    >
                                        <option selected="">select</option>
                                        {buildcurrentcountry()}
                                    </select>
                                    {message.currentcountry ? (
                                        <label className="hive-form-mandatory">{message.currentcountry}</label>
                                    ) : null}
                                </div>
                                <div className="col-md-6 mb-4">
                                    <label htmlFor="currentaddress-state" className="form-label hive-form-label">
                                        State<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        className="form-select hive-form-select"
                                        aria-label="Default select example"
                                        id="currentaddress-state"
                                        name="currentstate"
                                        value={state.currentstate}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    >
                                        <option selected="">select</option>
                                        {buildcurrentstate()}
                                    </select>
                                    {message.currentstate ? <label className="hive-form-mandatory">{message.currentstate}</label> : null}
                                </div>
                                <div className="col-md-6 mb-4">
                                    <label htmlFor="currentaddress-pincode" className="form-label hive-form-label">
                                        Pin Code<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="currentaddress-pincode"
                                        aria-describedby="Pin Code"
                                        name="currentpincode"
                                        placeholder="Enter here"
                                        maxLength={6}
                                        value={state.currentpincode}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.currentpincode ? (
                                        <label className="hive-form-mandatory">{message.currentpincode}</label>
                                    ) : null}
                                    {rejexMessage.currentpincode ? (
                                        <label className="hive-form-mandatory">{rejexMessage.currentpincode}</label>
                                    ) : null}
                                </div>
                                {/* </div> */}
                            </div>
                        ) : null}
                        {(pagemode === 'true' && addressType === 'Permanent Address') || pagemode === 'false' ? (
                            // < div
                            //   className="modal-body employeeInfoScroll"
                            // >
                            <div className="row mb-1">
                                <h1 className="profile-popup-subheader">Permanent Address</h1>
                                <div className="col-md-12 mb-4">
                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input hive-form-check-input"
                                            type="checkbox"
                                            id="candidate-present-address"
                                            // value="Choice same as current addr"
                                            name="sameascurrentaddress"
                                            checked={state.sameascurrentaddress}
                                            value={state.sameascurrentaddress}
                                            onChange={(e) => {
                                                handleChecked(e);
                                            }}
                                        />

                                        <label className="form-check-label hive-form-check-label" htmlFor="candidate-present-address">
                                            Same as Current Address
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-4" hidden={showPermanentField}>
                                    <label htmlFor="presentaddress-house" className="form-label hive-form-label">
                                        House / Building no<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="presentaddress-house"
                                        aria-describedby="House / Building Name"
                                        name="perhousenumber"
                                        placeholder="Enter here"
                                        maxLength={25}
                                        value={state.perhousenumber}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.perhousenumber ? (
                                        <label className="hive-form-mandatory">{message.perhousenumber}</label>
                                    ) : null}
                                </div>
                                <div className="col-md-6 mb-4" hidden={showPermanentField}>
                                    <label htmlFor="presentaddress-street" className="form-label hive-form-label">
                                        Road / Street / Lane
                                        <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="presentaddress-street"
                                        aria-describedby="Road / Street / Lane"
                                        name="perstreet"
                                        placeholder="Enter here"
                                        maxLength={225}
                                        value={state.perstreet}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.perstreet ? <label className="hive-form-mandatory">{message.perstreet}</label> : null}
                                </div>
                                <div className="col-md-6 mb-4" hidden={showPermanentField}>
                                    <label htmlFor="presentaddress-locality" className="form-label hive-form-label">
                                        Area / Locality / Sub Division
                                        <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="presentaddress-locality"
                                        aria-describedby="Area / Locality / Sub Division"
                                        name="perarea"
                                        placeholder="Enter here"
                                        value={state.perarea}
                                        maxLength={225}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.perarea ? <label className="hive-form-mandatory">{message.perarea}</label> : null}
                                </div>
                                <div className="col-md-6 mb-4" hidden={showPermanentField}>
                                    <label htmlFor="presentaddress-town" className="form-label hive-form-label">
                                        Town / City / District
                                        <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="presentaddress-town"
                                        aria-describedby="Town / City / District"
                                        name="pertown"
                                        placeholder="Enter here"
                                        value={state.pertown}
                                        maxLength={225}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.pertown ? <label className="hive-form-mandatory">{message.pertown}</label> : null}
                                </div>
                                <div className="col-md-6 mb-4" hidden={showPermanentField}>
                                    <label htmlFor="presentaddress-country" className="form-label hive-form-label">
                                        Country<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        className="form-select hive-form-select"
                                        aria-label="Default select example"
                                        id="presentaddress-country"
                                        name="percountry"
                                        value={state.percountry}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                            LoadDataperstate(e);
                                        }}
                                    >
                                        <option selected="">select</option>
                                        {buildpercountry()}
                                    </select>
                                    {message.percountry ? <label className="hive-form-mandatory">{message.percountry}</label> : null}
                                </div>
                                <div className="col-md-6 mb-4" hidden={showPermanentField}>
                                    <label htmlFor="presentaddress-state" className="form-label hive-form-label">
                                        State<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        className="form-select hive-form-select"
                                        aria-label="Default select example"
                                        id="presentaddress-state"
                                        name="perstate"
                                        value={state.perstate}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    >
                                        <option selected="">select</option>
                                        {buildperstate()}
                                    </select>
                                    {message.perstate ? <label className="hive-form-mandatory">{message.perstate}</label> : null}
                                </div>
                                <div className="col-md-6 mb-4" hidden={showPermanentField}>
                                    <label htmlFor="presentaddress-pincode" className="form-label hive-form-label">
                                        Pin Code<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="presentaddress-pincode"
                                        aria-describedby="Pin Code"
                                        name="perpincode"
                                        placeholder="Enter here"
                                        maxLength={6}
                                        value={state.perpincode}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.perpincode ? <label className="hive-form-mandatory">{message.perpincode}</label> : null}
                                    {rejexMessage.perpincode ? (
                                        <label className="hive-form-mandatory">{rejexMessage.perpincode}</label>
                                    ) : null}
                                </div>
                                {/* </div> */}
                            </div>
                        ) : null}

                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="btn hive-btn-secondary" data-bs-dismiss="modal" onClick={() => cancelClick()}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn hive-btn-primary"
                            onClick={() => {
                                submitClick();
                            }}
                            disabled={DisableSubmitBtn}
                        >
                            {submit}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        websocket: state.webSocketAPI,
    };
}

export default connect(mapStateToProps)(AddressDetail);
